import React, { Component } from "react";
import ReactDOM from "react-dom";
import { default as SelectPlugin, components } from "react-select";
import { isFieldValidClass, insertParam } from "~/js/utils";
import isEqual from "lodash.isequal";
import {Checkbox} from "./Checkbox";

const NOOP = () => {};
const NOOP_REACT_SELECT_STYLES = {
    // clearIndicator: NOOP,
    // container: NOOP,
    control: NOOP,
    dropdownIndicator: NOOP,
    // group: NOOP,
    // groupHeading: NOOP,
    indicatorsContainer: NOOP,
    indicatorSeparator: NOOP,
    input: (base) => {
        return { ...base, paddingBottom: 0, paddingTop: 0, margin: 0 };
    },
    // loadingIndicator: NOOP,
    // loadingMessage: NOOP,
    menu: NOOP,
    menuList: NOOP,
    // menuPortal: NOOP,
    // multiValue: NOOP,
    // multiValueLabel: NOOP,
    // multiValueRemove: NOOP,
    // noOptionsMessage: NOOP,
    option: NOOP,
    placeholder: NOOP,
    // singleValue: NOOP,
    valueContainer: NOOP,
};

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>
                <Checkbox
                    label={{ text: `${props.label}` }}
                    checked={props.isSelected}
                    onChange={() => null}
                    modifiers={['multiCheckbox']}

                />
            </components.Option>
        </div>
    );
};
const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <div className="select__arrow">
                <svg
                    width="13"
                    height="8"
                    viewBox="0 0 13 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.627 1.066l-5 5M6.627 6.066l-5-5"
                        stroke="#1D1D1D"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            </div>
        </components.DropdownIndicator>
    );
};

class SelectMulti extends Component {
    state = {
        selectedOption: { value: null, label: "" },
        placeholderText: 'All Dealerships'
    };

    componentDidMount() {
        let { options, defaultValue, value, preSelect, form, name } = this.props;

        if(options[0].value == ''){
            options.shift();
        }
        if (preSelect) {
            let newPlaceholder = "";
            // console.log(name, preSelect);
            this.setState({ selectedOption: preSelect });
            if((preSelect.length == 1 && preSelect[0].label == '') || preSelect.length == 0 ){
                newPlaceholder = "All Dealerships";
            }else{
                if(preSelect[0].label == '') {
                    newPlaceholder = "Dealerships (" + String(preSelect.length-1) + ")";
                }else{
                    newPlaceholder = "Dealerships (" + String(preSelect.length) + ")";

                }
            }
            this.setState({placeholderText: newPlaceholder} );
        }



        if(value) {
            if (value !== defaultValue) {
                this.setState({selectedOption: value});
                return;
            }
        }

        // If defaultValue exists
        if (defaultValue) {
            this.setState({ selectedOption: defaultValue });
            return;
        }

        // If using Formik
        if (form) {
            // Find initial value for this name in the options array
            const option = this.checkOptions(options, form.initialValues[name]);
            if (option) {
                this.setState({ selectedOption: option });
                return;
            }
        }

        // Else find empty value in the array, if exists
        // const index = options.findIndex((o) => o.value === "");
        //
        // // If empty value exists, select empty value
        // if (index !== -1) {
        //     const selectedOption = options[index];
        //     this.setState({ selectedOption });
        // }
    }

    componentDidUpdate(prevProps) {
        const { defaultValue, value, options, form, name } = this.props;
        const { selectedOption } = this.state;
        // If options array got updated
        if (!isEqual(options, prevProps.options) && selectedOption !== null) {
            // console.log(name, 'If options array got updated');
            // If defaultValue exists
            if (defaultValue) {
                this.setState({ selectedOption: defaultValue });
            } else if (form) {
                // Find initial value for this name in the options array
                const option = this.checkOptions(
                    options,
                    form.initialValues[name]
                );

                if (option) {
                    form.setFieldValue(name, option.value);
                    this.setState({ selectedOption: option });
                }
            } else {
                this.setState({ selectedOption: null });
            }
        }

        // For cases when we want to contol the selected value from the parent components
        // For example on "clear" click
        if (typeof value !== "undefined") {
            // console.log(name, 'typeof value !== "undefined"', value);
            if (value !== selectedOption.value) {
                const option = this.checkOptions(options, value);

                if (option) {
                    this.setState({ selectedOption: option });
                }
            }
        }

        // For cases when the form value updates
        if (form && selectedOption) {
            if (form.values[name] !== selectedOption.value) {
                let option = "";
                if(form.values[name]) {
                    option = this.checkOptions(options, form.values[name]);
                }else{
                    option = this.checkOptions(options, selectedOption);
                }

                // console.log('checkOptions', option)

                if (option) {


                    this.setState({ selectedOption: option });
                    // console.log(form, form.values.make);
                    // form.validateField(name);
                }
            }
        }
    }

    checkOptions = (options, value) => {
        let option = null;

        for (let i = 0; i < options.length; i++) {
            const o = options[i];

            if (o.options) {
                const index = o.options.findIndex((oo) => oo.value === value);

                if (index !== -1) {
                    option = o.options[index];
                    break;
                }
            } else {
                if (o.value === value) {
                    option = o;
                    break;
                }
            }
        }
        return option;
    };

    handleChange = (selectedOption) => {
        const { onChange, form, name } = this.props;

        this.setState({ selectedOption });

        let newPlaceholder = "";
        if(selectedOption == null){
            selectedOption = [];
        }
        if((selectedOption.length == 1 && selectedOption[0].label == '') || selectedOption.length == 0 ){
            newPlaceholder = "All Dealerships";
        }else{
            if(selectedOption[0].label == '') {
                newPlaceholder = "Dealerships (" + String(selectedOption.length-1) + ")";
            }else{
                newPlaceholder = "Dealerships (" + String(selectedOption.length) + ")";

            }
        }
        this.setState({placeholderText: newPlaceholder} );

        if (onChange){
            onChange(selectedOption);
        }

        // If using Formik
        if (form) {
            // Hook to update form value
            const value = selectedOption ? selectedOption.value : null;
            form.setFieldValue(selectedOption);
            // form.handleChange({ target: { name, value } });
        }
    };

    handleBlur = (e) => {
        const { form, name } = this.props;
        // this is going to call setFieldTouched and manually update touched.topcis
        if (form) {
            form.setFieldTouched(name, true);
            form.handleBlur(e);
        }
    };

    render() {
        const {
            modifiers,
            pre,
            onChange,
            form,
            name,
            preSelect,
            value,
            ...rest
        } = this.props;
        const { selectedOption } = this.state;

        let className = `select`;
        if (modifiers) modifiers.forEach((m) => (className += ` select--${m}`));

        if (selectedOption) {
            if (selectedOption.value === "") className += ` is-empty-selected`;
            else className += ` is-value-selected`;
        }

        if (form) className += ` ${isFieldValidClass(name, form)}`;
        // console.log(rest);
        return (
            <div className={className}>
                {pre ? <div className="select__pre">{pre}</div> : null}
                <SelectPlugin
                    isSearchable={false}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    className={`select__wrap`}
                    classNamePrefix="select"
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    value={selectedOption}
                    placeholder={this.state.placeholderText}
                    isClearable={true}
                    controlShouldRenderValue={false}
                    {...rest}
                    components={{ DropdownIndicator, Option }}
                    styles={NOOP_REACT_SELECT_STYLES}
                />
            </div>
        );
    }
}

const SelectMultiDOM = (el, props) => {
    ReactDOM.render(<SelectMulti {...props} />, el);
};

export { SelectMulti, SelectMultiDOM };
